import React, { useState, useEffect } from 'react';
import DimpleDivider from '@tds/core-dimple-divider';
import Heading from '@tds/core-heading';
import { Download } from '@tds/core-interactive-icon';
import PropTypes from 'prop-types';
import FilesList from './components/filesList';
import { FieldWrapper } from '../css';
import request, { apiHost } from '../../../utils/request';
import { getLocale } from '../../../misc';
import FileUpload from './components/fileUpload';

const Attachements = ({ orderData }) => {
  const locale = getLocale();
  const { id: orderId } = orderData;
  const [filesList, setFilesList] = useState([]);

  useEffect(() => {
    request.get(`/orders/${orderId}`).then(data => {
      setFilesList(data.data.attachments);
    });
  }, []);

  const addFileToList = newFiles => {
    setFilesList([...filesList, ...newFiles]);
  };

  const removeFileFromList = id => {
    const updatedFileList = filesList.filter(file => file.id !== id);
    setFilesList(updatedFileList);
  };
  const getLink = () => (
    <li
      className="list-group-item"
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <div style={{ backgroundColor: 'transparent' }}>Proposal PDF</div>
      <div style={{ backgroundColor: 'transparent' }}>
        <Download
          onClick={() => {
            window.open(
              `${apiHost}/orders/${orderData.id}/proposal-pdf?lang=${locale}`
            );
          }}
          a11yText="Download"
        />
      </div>
    </li>
  );

  const getLinkContract = () => (
    <li
      className="list-group-item"
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <div style={{ backgroundColor: 'transparent' }}>Contract PDF</div>
      <div style={{ backgroundColor: 'transparent' }}>
        <Download
          onClick={() => {
            window.open(
              `${apiHost}/orders/${orderData.id}/quote-pdf?lang=${locale}`
            );
          }}
          a11yText="Download"
        />
      </div>
    </li>
  );

  return (
    <>
      <DimpleDivider />
      <Heading level="h2" tag="h4">
        Attachments
      </Heading>
      <div className="card" style={{ marginTop: '1rem' }}>
        <div className="card-header">
          <Heading level="h4">Proposal/Contract PDF</Heading>
        </div>
        <ul className="list-group list-group-flush">{getLink()}</ul>
        <ul className="list-group list-group-flush">{getLinkContract()}</ul>
      </div>
      <FieldWrapper>
        {filesList && filesList.length > 0 && (
          <FilesList
            filesList={filesList}
            orderId={orderId}
            removeFileFromList={removeFileFromList}
          />
        )}
        {<FileUpload addFileToList={addFileToList} orderId={orderId} />}
      </FieldWrapper>
    </>
  );
};

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired
};

export default Attachements;
